import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProfileComponent } from './profile/profile.component';
import { SignatureComponent } from './signature/signature.component';
import { CongesComponent } from './conges/conges.component';
import { ChangePasswordComponent } from './change-password/change-password.component';

const routes: Routes = [
 

  { path: '', component: ProfileComponent },

  { 
    path: 'account', 
    children: [
      {
        path: 'profile',
        component: ProfileComponent,
        data: {breadcrumb: 'profile'}
      },
      
      { 
        path: 'change-password', 
        component: ChangePasswordComponent,
        data: {breadcrumb: 'Change password'}
      },
      
      { 
        path: 'signature', 
        component: SignatureComponent,
        data: {breadcrumb: 'signature'}
      },

      { 
        path: 'conges', 
        component: CongesComponent,
        data: {breadcrumb: 'signature'}
      },

    ]
  },


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule { }